/* eslint-disable camelcase */
/**
 *
 * BIGTINCAN - CONFIDENTIAL
 *
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of BigTinCan Mobile Pty Ltd and its suppliers,
 * if any. The intellectual and technical concepts contained herein are proprietary to BigTinCan Mobile Pty Ltd and its
 * suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or reproduction of this material is strictly forbidden unless prior
 * written permission is obtained from BigTinCan Mobile Pty Ltd.
 *
 * @package app.bigtincan.dsr
 * @copyright 2010-2020 BigTinCan Mobile Pty Ltd
 * @author Shibu Bhattarai <shibu.bhattarai@bigtincan.com>
 */

import { AxiosResponse } from 'axios';
import {
  LOGIN_USER_LOGOUT,
  LOGIN_USER_LOGIN_REQUEST,
  LOGIN_USER_LOGIN_REQUEST_FAIL,
  LOGIN_USER_LOGIN_REQUEST_SUCCESS,
  LoginKnownAction,
} from './type';

import { AppThunkAction } from '../appThunkAction';
import { HttpStatusCode } from '../../constant/httpStatusCode';
import { BrowserStorageKey } from '../../constant/storage';
import hubService from '../../api/services/hub';

export const getNewToken = (): AppThunkAction<LoginKnownAction> => async (dispatch) => {
  dispatch({ type: LOGIN_USER_LOGIN_REQUEST });

  const result = await hubService.getNewToken();

  if (result.hasErrors) {
    const error = result.value as any as AxiosResponse;

    dispatch({
      type: LOGIN_USER_LOGIN_REQUEST_FAIL,
      error: {
        message: result.errors.join(' '),
        status: error ? error.status : 0,
      },
    });
    // if error is undefined forced logout
    // forced logout if token fails to be renewed due to unauthorized
    if (!error || error.status === HttpStatusCode.UNAUTHORIZED) {
      const root = document.getElementById('root');
      if (root) root.className = '';
      localStorage.clear();
    }

    return;
  }

  localStorage.setItem(BrowserStorageKey.ACCESS_TOKEN, result.value.access_token);
  localStorage.setItem(BrowserStorageKey.EXPIRES_IN, result.value.expires_in.toString());
  localStorage.setItem(BrowserStorageKey.LOGGED_TIME, new Date().getTime().toString());
  localStorage.setItem(
    BrowserStorageKey.REFRESH_TOKEN,
    result.value.refresh_token,
  );

  dispatch({ type: LOGIN_USER_LOGIN_REQUEST_SUCCESS });
};

export const setToken = (token: any): AppThunkAction<LoginKnownAction> => async (dispatch) => {
    dispatch({ type: LOGIN_USER_LOGIN_REQUEST });
    localStorage.setItem(BrowserStorageKey.ACCESS_TOKEN, token.access_token);
    localStorage.setItem(BrowserStorageKey.EXPIRES_IN, token.expires_in.toString());
    localStorage.setItem(BrowserStorageKey.LOGGED_TIME, new Date().getTime().toString());
    localStorage.setItem(BrowserStorageKey.REFRESH_TOKEN, token.refresh_token);
};

export const logout = (): AppThunkAction<LoginKnownAction> => async (dispatch) => {
  const root = document.getElementById('root');
  if (root) root.className = '';

  localStorage.clear();

  dispatch({ type: LOGIN_USER_LOGOUT });

  window.location.reload(true);
};
